"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("@material-ui/core/utils");

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m20.023 18.928-3.722-3.724a7.011 7.011 0 0 0 1.553-4.403c0-3.888-3.164-7.051-7.052-7.051s-7.051 3.163-7.051 7.051 3.163 7.051 7.051 7.051a7.014 7.014 0 0 0 4.404-1.553l3.723 3.723a.77.77 0 0 0 1.095 0 .773.773 0 0 0 0-1.095zM5.299 10.802c0-3.034 2.469-5.502 5.502-5.502s5.503 2.468 5.503 5.502-2.469 5.502-5.503 5.502a5.509 5.509 0 0 1-5.502-5.502z"
}), 'Search');

exports.default = _default;